import axiosInstance from "@/utils/axiosInstance";

export interface PCDDOWorkloadItem {
  ddo_user_id: number;
  ddo_username: string;
  active_assignments: number;
  stale_assignments: number;
  locked_submissions: number;
  oldest_assignment_at?: string | null;
}

export interface PCDashboardResponse {
  pc_user_id: number;
  tenant_id: number;
  ddo_count: number;
  active_assignments: number;
  stale_assignments: number;
  unassigned_visible_submissions: number;
  routing_failures: number;
  workload_spread: number;
  ddo_workloads: PCDDOWorkloadItem[];
}

export interface PCSubmissionQueueItem {
  submission_id: number;
  tenant_id: number;
  assigned_to_user_id: number;
  assigned_to_username: string;
  status: string;
  program_code?: string | null;
  academic_year?: number | null;
  assignment_source: string;
  routing_reason?: string | null;
  assigned_at: string;
  locked: boolean;
  age_days?: number | null;
  lifecycle_phase: string;
  review_state: string;
  latest_governance_event: string;
  latest_governance_actor?: string | null;
  latest_governance_reason?: string | null;
  latest_governance_phase?: string | null;
  latest_return_source?: string | null;
  actionability_state: string;
  blocking_reason: string;
  executable_action_count: number;
  assignment_state: string;
  assignment_age_days?: number | null;
}

export interface PCSubmissionQueueResponse {
  total: number;
  items: PCSubmissionQueueItem[];
}

export interface PCSupervisoryInterventionPayload {
  action_code: string;
  intervention_reason: string;
  remarks?: string;
}

export async function fetchPCDashboard(): Promise<PCDashboardResponse> {
  const res = await axiosInstance.get<PCDashboardResponse>("/pc/dashboard");
  return res.data;
}

export async function fetchPCSubmissions(): Promise<PCSubmissionQueueResponse> {
  const res = await axiosInstance.get<PCSubmissionQueueResponse>("/pc/submissions");
  return res.data;
}

export async function submitPCSupervisoryIntervention(
  submissionId: number,
  payload: PCSupervisoryInterventionPayload
): Promise<unknown> {
  const res = await axiosInstance.post(
    `/pc/submissions/${submissionId}/intervene`,
    payload
  );
  return res.data;
}
